export default __webpack_public_path__ + "static/media/huobi.a34060a5.png";